<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <el-overlay-loading :subText="getSubMsgText" :text="getMsgText" card :absolute="false" :loading="submitLoading" />
    <form @keydown.enter.prevent="submit()">
      <!-- data provider  -->
      <div>
        <!-- title  -->
        <h2 class="mb-1" style="display: flex;">{{ $t('Peržiūra') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras.  Nauja prokūra. Peržiūra" title></el-tooltip></h2>
        <v-row class="mb-0 pb-0">
          <v-col v-if="showPdfFile" class="pb-0" cols="12" md="12">
            <el-PDF-viewer download :file="pdfFile" />
          </v-col>
          <v-col v-else class="pb-4" cols="12" md="12"></v-col>
          <template v-for="(checkbox, index) in formData.checkboxes">
             <v-col :key="index" class="pt-0 pb-4" cols="12" md="12">
              <el-checkbox
                required
                :disabled="modeReadonly"
                notTranslated
                :label="checkbox.text"
                v-model="checkbox.value"
                :validateKey="index"
              >
              </el-checkbox>
            </v-col>
          </template>

          <template v-if="showDocuments">
            <v-col class="pb-0" cols="12" md="12">
              <h2 class="mb-1" style="display: flex">
                {{ $t('Dokumentai') }}
                <el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Dokumentai" title></el-tooltip>
              </h2>
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <v-data-table
                class="mb-4 custom-table"
                :loading="loading"
                :headers="headers"
                :items="documents"
                :hide-default-footer="true"
                :header-props="{
                  sortByText: $t('Rūšiuoti pagal'),
                }"
              >
               <!-- custom templates -->
                <template #[`item.size`]="{ item }">
                  <span>{{bytesToSize(item.size)}}</span>
                </template>
                <template #[`item.actions`]="{ item }">
                  <div class="nowrap">
                    <el-table-action
                      :item="setItem(item)"
                      @downloadItem="download(item)"
                    />
                  </div>
                </template>
                <!-- basic templates -->
                <template slot="loading"> {{ $t('Kraunasi...') }} </template>
                <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
                <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
              </v-data-table>
            </v-col>
          </template>

          <v-col class="pt-0 pb-4" cols="12" md="12">
            <h2 class="mb-1" style="display: flex;">{{ $t('Dokumento sudarytojas') }}</h2>
            <v-card outlined>
              <v-card-text class="pa-2">
                <v-row>
                  <v-col><span>{{ dataProviderName }}</span><span v-if="dataRepresentitiveName">{{ ` (${dataRepresentitiveName})` }}</span></v-col>
                  <v-col style="text-align: end;"><span>{{ documentPreparedAt }}</span></v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- SIGNATURES -->
          <v-col class="pt-0 pb-4" cols="12" md="12">
            <signatures-list
              :signatures="signatures"
              :status="formData.status"
              :editMySignatures="formData.canEditSignatures"
              :mySignature="myParentSignature"
              :editMySignaturesTitle="getSignatureEditMyTitle"
              :listTitle="getSignatureListTitle"
              :modalCardTitle="getSignaturesModalTitle"
              :dataType="getDataType"
              :loadingList="pageloading"
              :inJournalType="inJournalType"
            ></signatures-list>
          </v-col>

          <v-col class="pt-0 pb-4" cols="12" md="12">
            <v-card  outlined>
              <v-card-text class="pa-2">
                <v-row>
                  <v-col class="pb-0" cols="12" >
                    <span><strong>{{ `${$t('Būsena')}: ` }}</strong><span :class="getStatusClass">{{ getStatus }}</span></span>
                  </v-col>
                    <v-col class="pt-1" cols="12" >
                      <span><strong>{{ `${$t('Pasirinkta dokumento kalba')}: ` }}</strong>{{ getSelectedLang }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
        </v-row>
      </div>
      <!-- actions  -->
      <v-card-actions v-if="!showSigningComponent">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            v-if="waitingApproval"
            class="mr-1"
            color="secondary"
            title="Atgal"
            @click.native.stop="backToList()"
            :loading="loading"
          />
          <el-button
            v-if="!waitingApproval"
            class="mr-1"
            color="secondary"
            icon="atgal"
            title="Atgal"
            @click.native.stop="back()"
            :loading="loading"
          />
           <el-button
            class="mr-1"
            v-if="canCancelSigning"
            title="Atšaukti pasirašymą"
            :loading="loading"
            @click.native="beforeCancel()"
            color="secondary"
            icon="atšaukti"
          />
          <el-button
            v-if="canPassToRepresenterConfirm"
            title="Perduoti patikrinimui"
            :loading="loading"
            @click.native="passToRepresenterConfirm()"
            color="primary"
            icon="pirmyn"
          />
          <v-tooltip v-if="canConfirmRepresenters" top max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="primary"
                v-bind="attrs"
                v-on="on"
                class="v-btn-primary"
                :loading="loading"
                @click.native="beforeApproveRepresenters()"
                >
                <v-icon small>mdi-arrow-right</v-icon>
                {{ $t('Perduoti atstovų patikrinimui') }}
              </v-btn>
            </template>
            <div class="tooltip-text">{{ $t('Registro tvarkytojas patikrins, ar nurodyti asmenys vadovaujantis Juridinių asmenų registro duomenimis turi teisę juridinio asmens vardu pasirašyti dokumentą. Patikrinimas gali užtrukti iki 2 darbo dienų.') }}</div>
          </v-tooltip>
          <el-button
            v-if="canPassToSigning"
            title="Perduoti patikrinimui"
            :loading="loading"
            @click.native="next()"
            color="primary"
            icon="pirmyn"
          />
           <el-button
            class="mr-1"
            v-if="canRefuseToSign"
            title="Atsisakyti pasirašyti"
            :loading="loading"
            @click.native="beforeRefuse()"
            color="secondary"
            icon="atšaukti"
          />
          <template v-if="canSign">
            <el-button
              v-if="qualifiedSignatureRequired"
              title="Pasirašyti el. parašu"
              :loading="loading"
              @click.native="initElSigning()"
              color="primary"
              icon="pirmyn"
            />
            <el-button
              v-if="!qualifiedSignatureRequired"
              :title="inJournalType == '420' ? this.$t('Pasirašyti') : this.$t('Pateikti')"
              :loading="loading"
              @click.native="next()"
              color="primary"
              icon="pirmyn"
            />
          </template>
          <!-- <el-button
            v-if="waitingApproval"
            disabled
            title="Laukiama pasirašymo"
            color="primary"
            icon="pirmyn"
          /> -->
        </v-row>
      </v-card-actions>
    </form>
    <!-- modals -->
    <modal-custom
      :title="$t('Pasirašymo atšaukimas')"
      :text="$t('Ar tikrai norite atšaukti pasirašymą?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showCancelModal"
      @confirmData="confirmCancel"
    />
    <modal-custom
      :title="$t('Atsisakymas pasirašyti')"
      :text="$t('Ar tikrai norite atsisakyti pasirašyti?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showRefuseModal"
      @confirmData="confirmRefuse"
    />
    <modal-custom
      :title="$t('Perduoti atstovų patikrinimui')"
      :text="$t('Registro tvarkytojas patikrins, ar nurodyti asmenys vadovaujantis Juridinių asmenų registro duomenimis turi teisę juridinio asmens vardu pasirašyti dokumentą. Patikrinimas gali užtrukti iki 2 darbo dienų.')"
      trueText="Perduoti patikrinimui"
      falseText="Ne"
      :loading="loading"
      v-model="showApproveRepresentersModal"
      @confirmData="approveRepresenters"
    />
    <modal-sign
      :openSign="showSigningComponent"
      :objectId="getId"
      objectType="in_journal"
      @cancelSigning="cancelSigning"
      @signed="signingSuccessfull"
      @stampDecision="stampDecision"
    />
  </v-container>
</template>

<script>
import InJournalStatuses from '@/components/constants/inJournalStatus'
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import errorNotifications from '@/mixins/errorNotifications'
import SignaturesList from '@/components/signatures/SignaturesList'
import ModalCustom from '@/components/modals/ModalCustom'
import Enums from '@/enums'
import math from '@/mixins/math'
import SavitarnaMenu from '@/components/constants/savitarnaMenu.js'
import ModalSign from '@/components/modals/ModalSign.vue'

export default {
  name: 'ProcurationStep4',
  components: {SignaturesList, ModalCustom, ModalSign},
  mixins: [userRole, unsavedData, errorNotifications, math],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      showApproveRepresentersModal: false,
      showCancelModal: false,
      showRefuseModal: false,
      inJournalType: null,
      kind: null,
      dataProviderName: null,
      dataRepresentitiveName: null,
      documentPreparedAt: null,
      pageloading: false,
      submitLoading: false,
      showAddPerson: false,
      stampRequired: false,
      loading: false,
      showSigningComponent: false,
      formData: {
        confirm: false,
        read_understood: false,
        confirm_data: false,
        calculation_procedure: false,
      },
      additionalData: {
        kind: null,
        in_journal_type: null,
      },
      bilingual: null,
      signatures: [],
      pdfFile: {},
      isUserPrincipal: false,
      documents: [],
      showEditSignaturesModal: false,
      myParentSignature: {},
    }
  },
  computed: {
    getDataType(){
      // Dėl vaizdavimo gimimo datos visose prokūrose
      return 'jur_representer_against_parent'
      // return this.kindPP ? 'jur_representer' : 'jur_representer_against_parent'
    },
     showEditSignatures(){
      return this.formData.canEditSignatures
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    showDocuments() {
      return this.documents.length > 0
    },
    kindPP(){
      return this.kind == 'PP' || false
    },
    getSignaturesModalTitle() {
      return this.kindPP ? this.$t('Atstovai ir kontaktai') : this.$t('Pasirašančiųjų eilė ir kontaktai')
    },
    getSignatureEditMyTitle() {
      return this.$t('Pridėti / Redaguoti prokūrą išduodančio valdymo organo narius ir kontaktus')
    },
    getSignatureListTitle() {
      return this.kindPP ? this.$t('Atstovai') : this.$t('Pasirašantys asmenys')
    },
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Dokumento pavadinimas'),
          align: 'start',
          value: 'original_filename',
        },
        {
          text: this.$t('Dydis'),
          align: 'start',
          value: 'size',
        },
        {
          text: this.$t('Įkėlimo data'),
          align: 'start',
          value: 'created_at',
        },
      ]
    },
    getSelectedLang(){
      let lang = this.$i18n.locale === 'lt' ? Enums.bilingualMandate.lt : Enums.bilingualMandate.en
      return lang[this.bilingual]
    },
    getStatus(){
      let statuses = this.$i18n.locale === 'lt' ? Enums.journalType.lt : Enums.journalType.en
      return statuses[this.formData.status]
    },
    getStatusClass(){
      return this.formData.status == InJournalStatuses.ATSAUKTAS ? 'text-red' : ''
    },
    canCancelSigning(){
      return this.formData.buttons?.cancelSigning
    },
    canPassToSigning(){
      return this.formData.buttons?.passToSigning
    },
    canPassToRepresenterConfirm(){
      return this.formData.buttons?.passToRepresenterConfirm
    },
    canConfirmRepresenters(){
      return this.formData.buttons?.confirmRepresenters
    },
    canSign(){
      return this.formData.buttons?.sign
    },
    canRefuseToSign(){
      return this.formData.buttons?.refuseToSign
    },
    toBasket(){
      return this.formData.buttons?.afterSignBasket
    },
    showPdfFile(){
      return this.pdfFile && Object.keys(this.pdfFile).length != 0
    },
    waitingApproval(){
      return this.formData.status == "806"
        || this.formData.status == "809"
        || this.formData.status == "813"
        || this.formData.status == "808"
        || this.formData.status == "807"
        || this.formData.status == "802"
        || this.formData.status == "816"
        || this.formData.status == "815"
        || this.formData.status == "810"
    },
    getConfirmText(){
      return this.notificationText('000035')
    },
    getReadUnderstoodText(){
      return this.notificationText('000036')
    },
    getConfirmDataText(){
      return this.notificationText('000037')
    },
    getCalculationProcedureText(){
      return this.notificationText('000038')
    },
    getId() {
      return this.$route.params.id || null
    },
    modeReadonly() {
      return this.formData.final
    },
    getMsgText(){
      return this.$t('Prašome palaukti.')
    },
    getSubMsgText(){
      return this.$t('Duomenys tikrinami registruose.')
    },
  },
  created() {
    this.getData()
  },
  methods: {
    initElSigning() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.showSigningComponent = true
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },

    cancelSigning() {
      this.showSigningComponent = false
    },

    stampDecision(decision) {
      this.stampRequired = decision
    },

    signingSuccessfull() {
      this.redirectToBasket()
      this.showSigningComponent = false
    },

    redirectToBasket() {
      if(this.toBasket  && !this.stampRequired){
        if (this.isLocal) {
          return this.$axios.post(`local/in-journals/${this.getId}/fake-payment`).then(
            this.$router.push({name: this.inJournalType == '420' ? 'savProcurations' : 'savDocuments'})
          );
        } else {
          return this.$emit('gotoStep', { step: '5', id: this.getId })
        }
      } else {
        this.$router.push({
            name: 'savDocumentView',
            params: {
              id: this.getId,
            },
          })
      }
      this.formData = {};
      this.pdfFile = {};
      return this.getData()
    },

    beforeApproveRepresenters() {
      this.showApproveRepresentersModal = true;
    },
    passToRepresenterConfirm (){
      this.pageloading = true;
      this.$axios
        .post(`in-journals/${this.getId}/passToRepresenterConfirm`)
        .then(() => {
          let link = SavitarnaMenu.MANO_DOKUMENTAI
          window.location.href = link
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err.response.data.message)
          this.pageloading = false
          this.loading = false
        })
    },
    approveRepresenters() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .post(`/in-journals/${this.getId}/signatures/confirm`)
        .then((res) => {
            let link = SavitarnaMenu.MANO_DOKUMENTAI
            window.location.href = link
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          if(err.response.status === 409){
            this.getData()
            this.showApproveRepresentersModal = false
          }
          this.loading = false
          this.pageloading = false
        })
    },
    setItem(item) {
      item.canDownload = true
      return item
    },
    next() {
      this.saveData()
    },
    backToList(){
      this.$router.push({ name: 'savDocuments' })
    },
    back() {
      this.$emit('gotoStep', { step: '3', id: this.getId })
    },
    getPdfFile() {
      this.pageloading = true

      this.$axios
        .get(`mandates/${this.formData.mandate_id}/preview`)
        .then((res) => {
          this.pdfFile = res.data
          this.pdfFile.original_filename = 'Peržiūra.pdf'
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    checkIfConfirm(){
      // this.formData.final = this.formData.confirm && this.formData.read_understood && this.formData.confirm_data
      this.formData.final = this.formData.has_signed
    },
    getData() {
      if (this.getId) {

        this.pageloading = true

        this.$axios
          .get(`in-journals/${this.getId}`)
          .then((res) => {
            this.inJournalType = res.data.inJournal.in_journal_type
            this.formData = res.data.inJournal.agreements
            this.kind =  res.data.inJournal.kind
            this.documents = res.data.inJournal.documents
            this.bilingual = res.data.inJournal.bilingual
            this.dataProviderName = res.data.inJournal.data_provider.fullname
            this.dataRepresentitiveName = res.data.inJournal.data_provider.representitive_fullname
            this.documentPreparedAt = res.data.inJournal.document_prepared_at
            this.signatures = res.data.inJournal.signatures
            this.isUserPrincipal = this.formData.is_data_provider && this.formData.is_first_to_sign
            this.formData.mandate_id = res.data.inJournal.mandate_id
            this.formData.canEditSignatures = res.data.inJournal.canEditSignatures
            this.additionalData.kind = res.data.inJournal.kind
            this.additionalData.in_journal_type = res.data.inJournal.in_journal_type
            this.checkIfConfirm()
            this.formData.status = res.data.inJournal.status
            this.initialForm()
            this.getPdfFile()
            this.myParentSignature = res.data.inJournal.myParentSignature
            this.qualifiedSignatureRequired = res.data.inJournal.signature_required
          })
          .catch((err) => {
            if(err.response.status === 404){
              return this.$router.push({ name: 'sav404' })
            } else {
              this.$root.$emit('DATA_ERROR', err.response.data.message)
            }
          })
          .finally(() => {
            this.pageloading = false
          })
      }
    },
    refuse(){
      this.loading = true
      this.pageloading = true
      this.submitLoading = true
      let formData = { ...this.formData }
      let url = `in-journals/${this.getId}/refuse`
      this.$axios.post(url, formData)
      .then((res) => {
        this.$root.$emit('DATA_OK_STEP')
        // then
        this.initialForm()
        this.formData = {};
        this.pdfFile = {};
        return this.getData()
      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      }).finally(() => {
        this.showRefuseModal=false
        this.loading = false
        this.pageloading = false
        this.submitLoading = false
      })
    },
    beforeCancel(){
      this.showCancelModal = true
    },
    confirmCancel(){
      this.cancel()
    },
    beforeRefuse(){
      this.showRefuseModal = true
    },
    confirmRefuse() {
      this.refuse()
    },
    cancel(){
      this.loading = true
      this.pageloading = true
      this.submitLoading = true
      let formData = { ...this.formData }
      let url = `in-journals/${this.getId}/cancel`
      this.$axios.post(url, formData)
      .then((res) => {
        this.$root.$emit('DATA_OK_STEP')
        // then
        this.initialForm()
        this.formData = {};
        this.pdfFile = {};
        return this.getData()
      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      }).finally(() => {
        this.showCancelModal = false
        this.loading = false
        this.pageloading = false
        this.submitLoading = false
      })
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    saveData(toRoute) {
      if(toRoute){
        return this.goToRoute()
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          this.pageloading = true
          this.submitLoading = true
          let formData = { ...this.formData }
          Object.keys(this.formData.checkboxes).map((key) => {
            formData[key] = this.formData.checkboxes[key].value
          })
          let url = `in-journals/${this.getId}/agreements`
          this.$axios
            .post(url, formData)
            .then((res) => {
            this.$root.$emit('DATA_OK_STEP')

              // then
              this.initialForm()
              if (toRoute) {
                  this.goToRoute()
              } else {
                this.redirectToBasket()
              }
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
              if(err.response.status === 409){
                this.getData()
              }
            })
            .finally(() => {
              this.loading = false
              this.pageloading = false
              this.submitLoading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
